import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import AuthContext from "../../contexts/AuthContext/AuthProvider";
import CardHeaderDefault from "../MainLayout/components/CardHeader/CardHeaderDefault";
import JegeropplysningerForm from "../MinSide/Components/JegeropplysningerForm";

export default function Velkommen(): JSX.Element {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <div className="h-dvh flex flex-col items-center">
      <CardHeaderDefault
        pathProps={{
          pageTitle: t("pages.velkommen.title"),
        }}
      />
      <div className={`max-h-screen overflow-y-auto w-full h-full bg-ldir-brown-300`}>
        <JegeropplysningerForm
          mode="velkommen"
          onCancel={async () => {
            auth.handleLogout();
            queryClient.clear();
            navigate("/login");
          }}
        />
      </div>
    </div>
  );
}
